( function( $, document, window ) {
	'use strict';

	// Slick Slideshow
	var $photoGalleries = $( document.querySelectorAll( '.photo-gallery-section .wrapper' ) );

	if ( $photoGalleries.length <= 0 ) {
		return;
	}

	$( document ).ready( function() {

		var slickifyGalleries = function() {

			$photoGalleries.each( function() {
				var $this = $( this ),
					$previousButton = $this.find( '.slick-prev' ),
					$nextButton = $this.find( '.slick-next' );

				$this.slick( {
					autoplay: false,
					centerMode: true,
					centerPadding: '25px',
					speed: 500,
					arrows: false,
					dots: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					mobileFirst: true,
					prevArrow: '',
					nextArrow: '',
					responsive: [
						{
							breakpoint: 767,
							settings: {
								arrows: true,
								centerPadding: '0',
								slidesToShow: 3,
								prevArrow: $previousButton,
								nextArrow: $nextButton
							}
						}
					]
				} );
			} );
		};

		// Run Slick
		slickifyGalleries();

	} );

} )( jQuery, document, window );
